import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const EditItemCat = ({ show, onClose, itemId, onUpdated }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');

    // Fetch the current item category data when the modal is opened
    useEffect(() => {
        if (show && itemId) {
            axios.get(`${baseURL}/item-categories/${itemId}`)
                .then(response => {
                    const { itemcategory_name, description } = response.data.data;
                    setName(itemcategory_name || '');
                    setDescription(description || '');
                })
                .catch(error => {
                    console.error("Error fetching item category:", error);
                });
        }
    }, [show, itemId]);

    const handleNameChange = (e) => {
        let value = e.target.value || '';

        // Allow only letters and spaces
        value = value.replace(/[^A-Za-z\s]/g, '');

        // Capitalize each word, preserve spaces
        value = value.replace(/\w\S*/g, (word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

        setName(value);

        if (value.length <= 25) {
            setNameLengthError('');
        }
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value || '';

        // Disallow only semicolons
        value = value.replace(/;/g, '');

        // Capitalize each word, preserve spaces
        value = value.replace(/\w\S*/g, (word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

        setDescription(value);

        if (value.length <= 100) {
            setDescLengthError('');
        }
    };

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        const safeName = name ?? '';
        const safeDescription = description ?? '';

        if (safeName.trim().length === 0) {
            setErrors(prev => ({
                ...prev,
                itemcategory_name: "This Field is Required"
            }));
            return;
        }

        if (safeName.length > 25) {
            setNameLengthError('Item Category (max 25 characters)');
            return;
        }

        if (safeDescription.length > 100) {
            setDescLengthError('Description (max 100 characters)');
            return;
        }

        axios.post(`${baseURL}/item-categories/${itemId}`, {
            itemcategory_name: safeName,
            description: safeDescription,
        })
        .then(() => {
            onClose();
            if (onUpdated) onUpdated();
        })
        .catch(error => {
            const res = error.response;
            if (res?.status === 400 || res?.status === 422) {
                if (res.data?.errors) {
                    setErrors(res.data.errors);
                } else if (res.data?.message) {
                    // If backend sends message only (e.g., duplicate name)
                    setErrors({ itemcategory_name: res.data.message });
                }
            } else {
                console.error("Update failed:", error);
            }
        });
    };

    return (
        <Modal show={show} onHide={onClose} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Item Category</h3>
                    <Button variant="" className="close px-6 py-2" onClick={() =>{
                    setErrors({});
                    onClose();
                    }}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">    
                            <label className="text-black font-w500 fs-7">
                                Item Category <span className="required">*</span>
                            </label>
                            <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Item Category"
                                    value={name}
                                     maxLength={25}
                                    onChange={handleNameChange}
                                />
                                {errors.itemcategory_name && (
                                    <div className="text-danger mt-1">{errors.itemcategory_name}</div>
                                )}
                                {nameLengthError && (
                                    <span className="text-danger">{nameLengthError}</span>
                                )}

                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                 maxLength={100}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                        <Button variant="secondary" size="sm" onClick={() =>{
                    setErrors({});
                    onClose();
                    }}>Cancel</Button>
                        <Button variant="primary" size="sm" onClick={handleSubmit}>Update Item Category</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditItemCat;
